import { Button } from '@/components/Button'

type CustomErrorProps = {
  code?: number
  message: string
  onClick?: () => void
}

export const CustomError = ({ code, message, onClick }: CustomErrorProps) => {
  return (
    <>
      <div className="content-cente min-h-full px-6 py-16 sm:py-24 md:grid md:place-items-center lg:px-8">
        <div className="mx-auto max-w-max">
          <main className="sm:flex">
            <p className="text-4xl font-bold tracking-tight text-red-600 sm:text-5xl">
              {code ?? 'Error'}
            </p>
            <div className="sm:ml-6">
              <div className="sm:border-l sm:border-gray-200 sm:pl-6">
                <h1 className="text-2xl font-bold tracking-tight text-gray-900 sm:text-2xl">
                  {message}
                </h1>
                <p className="mt-1 text-base text-gray-500">
                  Please try again or contact support.
                </p>
              </div>
            </div>
          </main>
          {onClick && (
            <div className="my-10 text-center">
              <Button style="primary" size="md" onClick={onClick}>
                Try again
              </Button>
            </div>
          )}
        </div>
      </div>
    </>
  )
}
